export default "__VITE_ASSET__D6LdS6Gf__"